import toast from 'react-hot-toast';

const ACTION_LABELS = {
  creacion:                     { label: 'Trámite / Solicitud Ingresada',    color: '#2563eb' },
  cambio_estado:                { label: 'Cambio de Estado',                 color: '#7c3aed' },
  asignacion:                   { label: 'Asignación de Responsable',        color: '#0284c7' },
  cambio_estado_y_asignacion:   { label: 'Cambio de Estado y Asignación',    color: '#6366f1' },
  envio_cotizacion:             { label: 'Cotización Emitida',               color: '#d97706' },
  confirmacion_pago:            { label: 'Pago Confirmado',                  color: '#059669' },
  rechazo_pago:                 { label: 'Pago Rechazado',                   color: '#dc2626' },
  devolucion:                   { label: 'Devolución de Fondos',             color: '#d97706' },
  adjunto_documento:            { label: 'Documento Adjuntado',              color: '#059669' },
  correo_enviado:               { label: 'Correo Enviado al Ciudadano',      color: '#d97706' },
  respuesta_ciudadano:          { label: 'Respuesta del Ciudadano',          color: '#0891b2' },
  rectificacion_tipo:           { label: 'Rectificación de Acto / Inscripción', color: '#ea580c' },
  marcado_exento_repertorio:    { label: 'Marcado Exento de Repertorio',     color: '#4f46e5' },
  desmarcado_exento_repertorio: { label: 'Desmarcado de Exención',           color: '#64748b' },
  reapertura_staff:             { label: 'Trámite Reabierto',                color: '#ea580c' },
  entrega_documentos:           { label: 'Documentos Entregados',           color: '#059669' },
  rechazo:                      { label: 'Rechazado',                        color: '#dc2626' },
  actualizacion:                { label: 'Actualización de Datos',           color: '#64748b' },
};

export const handleImprimirHistorial = (solicitud) => {
  const printWindow = window.open('', '_blank', 'width=800,height=900');
  if (!printWindow) {
    toast.error('El navegador bloqueó la ventana emergente para imprimir.');
    return;
  }

  const steps = solicitud.workflow_steps || [];

  const historyRows = steps.map(step => {
    const meta = ACTION_LABELS[step.action] || ACTION_LABELS.actualizacion;
    const dateStr = new Date(step.created_at).toLocaleString('es-CL', { dateStyle: 'short', timeStyle: 'short' });
    const author = step.action === 'respuesta_ciudadano' ? solicitud.nombre_solicitante : (step.worker?.name || 'Sistema');
    
    let contentHtml = '';
    if (step.payload) {
      if (step.payload.asunto) contentHtml += `<div style="margin-bottom: 4px;"><strong>Asunto:</strong> ${step.payload.asunto}</div>`;
      if (step.payload.mensaje || step.payload.comentario) {
        contentHtml += `<div style="margin-bottom: 4px; white-space: pre-wrap; font-style: italic;">"${step.payload.mensaje || step.payload.comentario}"</div>`;
      }
      if (step.payload.nota) {
        contentHtml += `<div style="margin-bottom: 4px; color: #64748b;">Nota: ${step.payload.nota}</div>`;
      }
      if (step.payload.archivos && step.payload.archivos.length > 0) {
        contentHtml += `<div style="margin-top: 4px;"><strong>Archivos:</strong><ul>${step.payload.archivos.map(a => `<li>${a}</li>`).join('')}</ul></div>`;
      }
    }

    return `
    <div style="margin-bottom: 20px; padding: 15px; border: 1px solid #e2e8f0; border-radius: 8px; border-left: 4px solid ${meta.color};">
      <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 8px; border-bottom: 1px solid #f1f5f9; padding-bottom: 8px;">
        <span style="font-weight: bold; color: ${meta.color}; font-size: 14px;">${meta.label}</span>
        <span style="font-size: 12px; color: #64748b;">${dateStr} · ${author}</span>
      </div>
      <div style="font-size: 13px; color: #334155; line-height: 1.5;">
        ${contentHtml || '<span style="color: #94a3b8;">(Sin detalles adicionales)</span>'}
      </div>
    </div>
    `;
  }).join('');

  // Generar sección de cotización (si existe)
  let cotizacionHtml = '';
  const itemsCotizados = (solicitud.items || []).filter(i => parseFloat(i.valor) > 0);
  const extrasCotizados = (solicitud.cotizacion_extras || []).filter(e => parseFloat(e.valor) > 0);
  const totalCotizacion = [...itemsCotizados, ...extrasCotizados].reduce((acc, i) => acc + (parseFloat(i.valor) || 0), 0);

  if (totalCotizacion > 0) {
    const rowsItems = itemsCotizados.map(item => `
      <tr>
        <td style="padding: 10px; border-bottom: 1px solid #e2e8f0; font-size: 13px;">${item.tipo_documento || '-'}</td>
        <td style="padding: 10px; border-bottom: 1px solid #e2e8f0; font-size: 13px; text-align: right; font-weight: 500;">$${new Intl.NumberFormat('es-CL').format(item.valor)}</td>
      </tr>
    `).join('');

    const rowsExtras = extrasCotizados.map(ex => `
      <tr>
        <td style="padding: 10px; border-bottom: 1px solid #e2e8f0; font-size: 13px;">${ex.descripcion || '-'}</td>
        <td style="padding: 10px; border-bottom: 1px solid #e2e8f0; font-size: 13px; text-align: right; font-weight: 500;">$${new Intl.NumberFormat('es-CL').format(ex.valor)}</td>
      </tr>
    `).join('');

    cotizacionHtml = `
      <div style="page-break-before: always; margin-top: 40px; padding-top: 40px; border-top: 2px dashed #cbd5e1;">
        <div class="header" style="margin-bottom: 20px; border-bottom: none;">
          <h2 class="title" style="font-size: 20px;">Cotización de Solicitud</h2>
        </div>

        <div class="section-title" style="margin-bottom: 10px;">1. Valores por Documento</div>
        <table style="width: 100%; border-collapse: collapse; margin-bottom: 20px;">
          <thead>
            <tr>
              <th style="text-align: left; padding: 10px; background: #f8fafc; border-bottom: 2px solid #e2e8f0; font-size: 12px; color: #475569; text-transform: uppercase;">Detalle / Documento</th>
              <th style="text-align: right; padding: 10px; background: #f8fafc; border-bottom: 2px solid #e2e8f0; font-size: 12px; color: #475569; text-transform: uppercase; width: 150px;">Precio</th>
            </tr>
          </thead>
          <tbody>
            ${rowsItems}
          </tbody>
        </table>

        ${rowsExtras ? `
          <div class="section-title" style="margin-bottom: 10px; margin-top: 30px;">2. Cobros Extras / Especiales</div>
          <table style="width: 100%; border-collapse: collapse; margin-bottom: 20px;">
            <thead>
              <tr>
                <th style="text-align: left; padding: 10px; background: #f8fafc; border-bottom: 2px solid #e2e8f0; font-size: 12px; color: #475569; text-transform: uppercase;">Descripción</th>
                <th style="text-align: right; padding: 10px; background: #f8fafc; border-bottom: 2px solid #e2e8f0; font-size: 12px; color: #475569; text-transform: uppercase; width: 150px;">Precio</th>
              </tr>
            </thead>
            <tbody>
              ${rowsExtras}
            </tbody>
          </table>
        ` : ''}

        <div style="background: #f8fafc; padding: 20px; border-radius: 8px; border: 2px solid #0f172a; display: flex; justify-content: space-between; align-items: center; margin-top: 30px;">
          <span style="font-weight: 800; font-size: 16px; color: #0f172a;">TOTAL COTIZACIÓN:</span>
          <span style="font-weight: 800; font-size: 22px; color: #0f172a;">$${new Intl.NumberFormat('es-CL').format(totalCotizacion)}</span>
        </div>

        ${solicitud.observaciones_cotizacion ? `
          <div class="section-title" style="margin-bottom: 10px; margin-top: 30px;">Observaciones de Cotización</div>
          <p style="font-size: 13px; color: #475569; white-space: pre-wrap; font-style: italic;">${solicitud.observaciones_cotizacion}</p>
        ` : ''}
      </div>
    `;
  }

  const html = `
    <!DOCTYPE html>
    <html>
      <head>
        <title>Historial - Solicitud ${solicitud.numero_seguimiento || ''}</title>
        <style>
          body {
            font-family: 'Inter', -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif;
            color: #0f172a;
            margin: 0;
            padding: 40px;
            background: #fff;
          }
          .header {
            text-align: center;
            margin-bottom: 30px;
            border-bottom: 2px solid #0f172a;
            padding-bottom: 20px;
          }
          .title {
            font-size: 22px;
            font-weight: 800;
            margin: 0 0 5px 0;
            text-transform: uppercase;
            letter-spacing: 1px;
          }
          .subtitle {
            font-size: 14px;
            color: #64748b;
            text-transform: uppercase;
          }
          .info-grid {
            display: grid;
            grid-template-columns: 1fr 1fr;
            gap: 20px;
            margin-bottom: 30px;
            background: #f8fafc;
            padding: 20px;
            border-radius: 8px;
            font-size: 13px;
          }
          .info-item {
            margin-bottom: 8px;
          }
          .info-label {
            color: #64748b;
            font-weight: 600;
            text-transform: uppercase;
            font-size: 11px;
            margin-bottom: 2px;
          }
          .info-value {
            font-weight: 500;
            color: #1e293b;
            font-size: 14px;
          }
          .section-title {
            font-size: 16px;
            font-weight: 700;
            color: #0f172a;
            text-transform: uppercase;
            margin-bottom: 20px;
            border-bottom: 1px solid #e2e8f0;
            padding-bottom: 8px;
          }
          .footer {
            text-align: center;
            font-size: 12px;
            color: #94a3b8;
            margin-top: 40px;
            border-top: 1px solid #e2e8f0;
            padding-top: 20px;
          }
          @media print {
            body { padding: 0; }
            .info-grid { background: #fff !important; border: 1px solid #e2e8f0; }
          }
        </style>
      </head>
      <body>
        <div class="header">
          <h1 class="title">Historial de Solicitud</h1>
          <div class="subtitle">Conservador de Bienes Raíces - San Carlos</div>
        </div>
        
        <div class="info-grid">
          <div>
            <div class="info-item"><div class="info-label">N° de Seguimiento</div><div class="info-value">${solicitud.numero_seguimiento || '-'}</div></div>
            <div class="info-item"><div class="info-label">Estado Actual</div><div class="info-value">${solicitud.estado?.nombre || '-'}</div></div>
            <div class="info-item"><div class="info-label">Fecha de Ingreso</div><div class="info-value">${new Date(solicitud.created_at).toLocaleDateString('es-CL')}</div></div>
          </div>
          <div>
            <div class="info-item"><div class="info-label">Solicitante</div><div class="info-value">${solicitud.nombre_solicitante || '-'}</div></div>
            <div class="info-item"><div class="info-label">RUT</div><div class="info-value">${solicitud.rut_solicitante || '-'}</div></div>
            <div class="info-item"><div class="info-label">Email</div><div class="info-value">${solicitud.email || '-'}</div></div>
            <div class="info-item"><div class="info-label">RUT Boleta</div><div class="info-value">${solicitud.rut_boleta || solicitud.rut_solicitante || '-'}</div></div>
            ${solicitud.boleta_razon_social ? `<div class="info-item"><div class="info-label">Razón Social Boleta</div><div class="info-value">${solicitud.boleta_razon_social}</div></div>` : ''}
            ${solicitud.boleta_giro ? `<div class="info-item"><div class="info-label">Giro Comercial</div><div class="info-value">${solicitud.boleta_giro}</div></div>` : ''}
            ${solicitud.boleta_correo ? `<div class="info-item"><div class="info-label">Correo Facturación</div><div class="info-value">${solicitud.boleta_correo}</div></div>` : ''}
            ${solicitud.boleta_direccion ? `<div class="info-item"><div class="info-label">Dirección Tributaria</div><div class="info-value">${solicitud.boleta_direccion}</div></div>` : ''}
          </div>
        </div>

        <div class="section-title">Registro de Eventos y Comunicaciones</div>
        
        ${historyRows.length > 0 ? historyRows : '<p style="color: #64748b; font-size: 14px;">No hay historial registrado para esta solicitud.</p>'}

        ${cotizacionHtml}

        <div class="footer">
          Documento generado el ${new Date().toLocaleString('es-CL')}
        </div>
        
        <script>
          window.onload = function() {
            window.print();
            setTimeout(function() { window.close(); }, 500);
          };
        </script>
      </body>
    </html>
  `;
  
  printWindow.document.write(html);
  printWindow.document.close();
};
